import { render, staticRenderFns } from "./chunai_xdca.vue?vue&type=template&id=04eb4dbe&scoped=true"
import script from "./chunai_xdca.vue?vue&type=script&lang=js"
export * from "./chunai_xdca.vue?vue&type=script&lang=js"
import style0 from "./chunai_xdca.vue?vue&type=style&index=0&id=04eb4dbe&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb4dbe",
  null
  
)

export default component.exports